export default "__VITE_ASSET__B8PiGq31__"